import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

interface Props {
  level: number;
}

const TierLevelBadge: React.FC<Props> = ({ level }) => (
  <Box
    width="20px"
    height="20px"
    align="center"
    justify="center"
    round="snackbarRound"
    background="background3"
    style={{ flexShrink: 0 }}
  >
    <Inscription size="12px" weight={500} color="textOnColor" lineHeight="18px">
      {level}
    </Inscription>
  </Box>
);

export default TierLevelBadge;
